import { ExcelParser16xoa9636ns39 as ExcelParser } from './ExcelParser.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance1m4lyta31lqem as Companion_instance } from './ExcelExpr.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ExcelFormulaClass;
function ExcelFormula() {
  if (ExcelFormulaClass === VOID) {
    class $ {
      constructor(source) {
        this.source_1 = source;
        this.expr_1 = (new (ExcelParser())(source)).parse_1rdbjn_k$();
        this.variables_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.extraFunctions_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      withValue_fbg6h3_k$(name, value) {
        var tmp0 = this.variables_1;
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.collections.set' call
        var key = name.toUpperCase();
        tmp0.put_4fpzoq_k$(key, value);
        return this;
      }
      eval_1uzks_k$() {
        var ctx = Companion_instance.build_cw5jyg_k$(this.variables_1, this.extraFunctions_1);
        return this.expr_1.eval_4bdj8k_k$(ctx);
      }
    }
    initMetadataForClass($, 'ExcelFormula');
    ExcelFormulaClass = $;
  }
  return ExcelFormulaClass;
}
//region block: exports
export {
  ExcelFormula as ExcelFormula1nf87837hifx4,
};
//endregion

//# sourceMappingURL=Excel.mjs.map
